<template>
  <div
    class="menu-box"
    :style="{
      // transform: !isNaN(itemIndex) && itemIndex % 2 > 0 ? 'translate(0px,100px)' : 'none',
    }"
    @click="itemClicked(item, 1)"
  >
    <div v-if="$store.getters.padSetting.menuMode !== true && itemOrderedQty > 0" class="ordered-qty">
      {{ itemOrderedQty }}
    </div>

    <div
      v-if="$store.getters.padSetting.menuMode !== true && itemOrderedQty > 0 && item.options.length == 0"
      class="ordered-qty-minus"
    >
      <v-icon @click.stop="itemClicked(item, -1)">
        mdi-minus
      </v-icon>
    </div>

    <div :class="['menu-img-box', 'pa-0']" v-if="$store.getters.menuImageVisible != 'hide'">
      <v-lazy-image v-if="item.imageUri" :src="item.imageUri" />
    </div>

    <div class="menu-content-box pa-0 px-1">
      <div class="-content">
        <div>
          {{ itemDescr }}
        </div>
        <div v-if="item != null && item.scalable && item.weight > 0" class="item-scale">
          {{ item.weight }} {{ item.weightUnit }} @ {{ $store.getters.itemPrice(item) | currency }}
        </div>
      </div>

      <div class="-footer">
        <div v-if="$store.state.Menu.menuClassify == 1" class="item-points">{{ item.redeemPoints }} pts</div>

        <div v-else-if="$store.state.Menu.menuClassify == 0">
          <div v-if="item.disabled" class="item-disabled">
            <div>{{ $t("item_disabled") }}</div>
          </div>

          <div v-else-if="item.orderDisabled" class="item-disabled">
            <div>{{ $t("item_call_server") }}</div>
          </div>

          <div v-else-if="itemSoldout" class="item-soldout">
            <div>{{ $t("soldout") }}</div>
          </div>

          <div v-else-if="$store.getters.itemDiscountedSub(item) != 0" class="item-price">
            {{ $store.getters.itemDiscountedSub(item) | currency }}
            <span
              v-if="$store.getters.itemSub(item) != $store.getters.itemDiscountedSub(item)"
              class="item-price-crossout"
            >
              {{ $store.getters.itemSub(item) | currency }}
            </span>
            <span class="mx-1 item-earn-points" v-if="$store.getters.pointEnabled && item.earnPoints > 0">
              ( +{{ item.earnPoints }} pts )
            </span>
          </div>
        </div>

        <div class="item-attribute">
          <v-icon v-if="item.favorite" class="attribute-icon-favorite">mdi-heart</v-icon>
          <v-icon v-if="item.attribute.includes('Vegetarian')" class="attribute-icon-veg">mdi-carrot</v-icon>
          <v-icon v-if="item.attribute.includes('Spicy2')" class="attribute-icon-spicy">mdi-chili-hot</v-icon>
          <v-icon v-else-if="item.attribute.includes('Spicy1')" class="attribute-icon-spicy">mdi-chili-medium</v-icon>
          <v-icon v-else-if="item.attribute.includes('Spicy')" class="attribute-icon-spicy">mdi-chili-mild</v-icon>
          <v-icon v-if="item.attribute.includes('Seafood')" class="attribute-icon-seafood">mdi-fish</v-icon>
          <v-icon v-if="item.attribute.includes('Peanut')" class="attribute-icon-peanut">mdi-peanut</v-icon>
          <img
            v-if="item.attribute.includes('Shellfish')"
            class="attribute-icon-seashell"
            src="@/assets/icon/shellfish-32x32.png"
          />
          <img
            v-if="item.attribute.includes('Dairy')"
            class="attribute-icon-dairy"
            src="@/assets/icon/dairy-fill-30x30.png"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VLazyImage from "v-lazy-image/v2";

export default {
  components: {
    VLazyImage,
  },

  props: {
    item: null,
    itemIndex: null,
  },

  computed: {
    itemDescr() {
      return this.$store.getters.itemDescr(this.item);
    },

    itemDetail() {
      return this.$store.getters.itemDetail(this.item);
    },

    itemSoldout() {
      return this.$store.getters.itemSoldout(this.item);
    },

    itemNotEnoughPoint() {
      return this.$store.getters.itemNotEnoughPoint(this.item);
    },

    itemOrderedQty() {
      return this.$store.getters.orderItemQtyTotal(this.item);
    },
  },

  methods: {
    itemClicked(item, orderQty) {
      if (this.$store.getters.padSetting.menuMode === true ||
          !item || item.disabled || item.orderDisabled || this.itemSoldout) return;

      this.$emit("itemClicked", { item: item, orderQty: orderQty });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/variables.scss";
$menu-box-height: 280px;
$menu-content-box-height: 90px;
$menu-content-price-height: 36px;
$ordered-qty-height: 32px;
//$item-img-height: 280px;
.menu-box {
  //border: dashed 1px rgb(220, 220, 220); // !important;
  height: $menu-box-height;
  position: relative;
  color: black;
  background-color: rgba(255, 255, 255, 0.9);

  .ordered-qty {
    position: absolute;
    right: 8px;
    top: 8px;
    width: $ordered-qty-height;
    height: $ordered-qty-height;

    line-height: $ordered-qty-height;
    background-color: var(--v-primary-base);
    color: var(--v-primaryText-base);
    text-align: center;
    vertical-align: middle;
    font-size: 1em;
    border-radius: calc(#{$ordered-qty-height} / 2); //solid 1px var(--v-primaryText-base);
  }

  .ordered-qty-minus {
    @extend .ordered-qty;

    right: 56px;
    background-color: var(--v-primaryText-base);

    display: flex;
    align-items: center;
    justify-content: center;

    .v-icon {
      color: var(--v-primary-base);
    }
  }

  .menu-img-box {
    height: calc(#{$menu-box-height} - #{$menu-content-box-height}); //$item-img-height;
    text-align: center;
    overflow: hidden;

    img {
      //border-radius: 10px;
      //border-radius: calc(#{$item-img-height} / 2);
      object-fit: cover;
      //width: $item-img-height;
      height: 100%;
      width: 100%;
    }
  }

  .menu-content-box {
    height: $menu-content-box-height;
    text-align: center;

    .-content {
      height: calc(#{$menu-content-box-height} - #{$menu-content-price-height});
      //min-height: 60px;
      //max-height: 60px;

      display: flex;
      justify-content: center;
      align-items: center;

      div {
        //color: black;
        font-size: 1em;
        font-weight: bold;
        margin-right: 12px;
        margin-left: 12px;

        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }

    .-footer {
      font-size: 1.2em;
      height: $menu-content-price-height;
      //font-weight: bold;

      .item-points {
        //font-weight: bold;
      }

      .item-price {
        //font-weight: bold;
      }

      .item-soldout {
        display: flex;
        justify-content: center;
        div {
          background-color: var(--v-warning-base);
          color: var(--v-warningText-base);
          padding: 4px 16px;
          border-radius: 18px;
          font-size: 0.65em;
        }
      }

      .item-disabled {
        @extend .item-soldout;
      }

      .item-price-crossout {
        text-decoration: line-through;
        color: var(--v-accent-base);
        font-weight: normal;
        padding-left: 4px;
        padding-right: 4px;
      }

      .item-attribute {
        .attribute-icon {
          background-color: white;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          text-align: center;
          margin: 0px 0px 5px 0px;
          padding: 2px;
          font-size: 1em;

          &-spicy {
            @extend .attribute-icon;
            color: red;
          }

          &-favorite {
            @extend .attribute-icon;
            color: var(--v-info-base);
          }

          &-veg {
            @extend .attribute-icon;
            color: green;
          }

          &-seafood {
            @extend .attribute-icon;
            color: skyblue;
          }

          &-peanut {
            @extend .attribute-icon;
            color: rgba(peru, 1);
          }

          &-seashell {
            @extend .attribute-icon;
            background-color: seashell;
            margin-bottom: -3px;
            margin-left: 4px;
          }

          &-dairy {
            @extend .attribute-icon;
            background-color: rgba(skyblue, 0.3);
            margin-bottom: -3px;
            margin-left: 4px;
          }
        }
      }
    }
  }
}
</style>
